import Dexie, { Table } from "dexie";

export interface FundHistory {
  fundId: string;
  endDate: number;
  startDate: number;
  lastUpdate: number;
  values: number[];
  isGestSep: boolean;
}

export class FundHistoryDexie extends Dexie {
  histories!: Table<FundHistory>;

  constructor() {
    super("Empirich");
    this.version(2).stores({
      histories: "++fundId, name, endDate, startDate, lastUpdate, values, isGestSep", // Primary key and indexed props
    });
  }
}

export const db = new FundHistoryDexie();
